import {v4 as uuidv4} from 'uuid';

//

/**
 *  Formats a number to have a fixed number of decimals
 * @param num Number to be formatted
 * @param digits Number of fixed decimals
 * @returns num as a formatted string
 */
export function formatPrice(num: number, digits: number = 2) {
    return Number(num).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }

export function numberWithThousandSeparator(x: number, separator: string = "", decimals: number = -1) {
    if (separator.length === 0) 
      return x.toString()

    if (x === undefined || x === null) {
      return '';
    }
  
    // Convert to string and split into integer and decimal parts
    const [integerPart, decimalPart] = x.toString().split('.');
    
    // Add thousands separators to integer part
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    
    const formattedDecimal = decimals > 0 ? ( (decimalPart || '00') + '00').slice(0, decimals) : decimalPart;

    // Return formatted integer with decimal part if it exists
    return formattedDecimal ? `${formattedInteger}.${formattedDecimal}` : formattedInteger;

  }



  /**
   * Takes a number such as 0.65 and returns it as a percent (65%)
   * 
   * @param num Number to be formatted 
   * @returns Number as %
   */
export function formatPercent(num: number) {
    return (num * 100).toFixed(0) + '%'
}

/**
 * 
 * @returns Generates a UUID string from which the "-" are removed
 */
export function getNewRecordID() {
  return  uuidv4().replace(/-/g, '');
}

/**
 * 
 * @param date : A date
 * @returns : Date formatted as a string such as 2024/01/09
 */
export const formatDateYYYYMMDD = (date: Date | string | undefined, separator : string  = '/') => {
  if (date === undefined) {
    return undefined;
  }

  // If date is a string, convert it to a date
  //
  if (typeof date === 'string') { 
    date = new Date(date);
  }

  
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}${separator}${month}${separator}${day}`;
}

  export const formatTimeHHMMSS = (date: Date | string | undefined, separator : string  = ':') => {
    if (date === undefined) {
      return undefined;
    }
  
    // If date is a string, convert it to a date
    //
    if (typeof date === 'string') { 
      date = new Date(date);
    }
  
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');
    return `${hour}${separator}${minute}${separator}${second}`;
  }


export const formatDateYYYYMMDDHHMMSS = (date: Date | string | undefined, separator : string  = '/') => {
  if (date === undefined) {
    return undefined;
  }

  return formatDateYYYYMMDD(date, separator) + ' ' + formatTimeHHMMSS(date, ":");
}

export const formatDateDDMMM = (date: Date): string => {
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long'
  }).split(' ').map((part, index) => 
    // Capitalize month name
    index === 1 ? part.charAt(0).toUpperCase() + part.slice(1) : part
  ).join(' ');
};
/**
 * 
 */
export const localData = {
  set(key: string, value: any) {
      localStorage.setItem(key, JSON.stringify(value));
  },
  get(key: string) {
      const stored = localStorage.getItem(key);
      return stored == null ? undefined : JSON.parse(stored);
  },
  remove(key: string, value: any) {
      localStorage.removeItem(key);
  }
};


export const ping = (url: string, timeout = 6000) => {
  return new Promise((resolve, reject) => {
    const urlRule = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]');
    if (!urlRule.test(url)) reject('invalid url');
    try {
      fetch(url)
        .then(() => resolve(true))
        .catch(() => reject(false));
      //setTimeout(() => {
      //  reject(false);
      // }, timeout);
    } catch (e) {
      reject(e);
    }
  });
};

export const isValidId = (id: string | undefined) => id && id.length > 0;
export const isValidPostiveNumber = (n: number | string| undefined) => Number(n) && !isNaN(Number(n)) && Number(n) > 0;
export const isValidRequiredString = (s: string | undefined) => s && s.trim().length > 0;
